import React from 'react';
import styled from 'styled-components';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.document_viewer_modal');

const LegendSquare = styled.div`
  min-width: 20px;
  max-width: 20px;
  min-height: 20px;
  max-height: 20px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
`;

const ResumeLegend = () => {
  return (
    <Stack direction="row" sx={{ height: 'fit-content', padding: 1 }}>
      <Stack direction="row" spacing={1}>
        <LegendSquare color={FullPalette.YELLOW_700} />
        <span>{t('exact_match')}</span>
      </Stack>
      <Stack direction="row" spacing={1}>
        <LegendSquare color={FullPalette.VIOLET_500} />
        <span>{t('similar_terms')}</span>
      </Stack>
    </Stack>
  );
};

export default ResumeLegend;
